// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"266":"5d80bc7b","707":"2b7301b6","942":"fac41556"}[chunkId] + ".chunk.css";
};